/** Strings owned by `src/manage/overview/` — "Beheer › Overzicht"
 * (PLAN-FASE3.md WP-05): the platform-staff-only KPI overview. No NPS or
 * AI-summary card — out of scope, see AdminOverviewPage.tsx. */
export const manageOverview = {
  page: {
    title: 'Overzicht',
    lead: 'Platformbrede kerncijfers: omzet, actieve bedrijven en gebruikers, en retentie.',
    activeCompanies: 'Actieve bedrijven',
    activeUsers: 'Actieve gebruikers',
    revenueThisMonth: 'Omzet deze maand',
    retention: 'Retentie (maand-op-maand)',
    retentionUnavailable: 'Nog geen data',
    retentionDetail: '{{retained}} van {{total}} bedrijven behouden',
  },
} as const;
